import React, { useContext, useEffect, useState } from 'react'
import { staticAssetsPath } from '../../../../configs/constants'
import { useSasToken } from '../../../../_hooks/useSasToken'
import MyAgents from './MyAgents'
import Explore from './Explore'
import { Spinner, DropdownItem, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { ChatbotContext } from '../context/ChatbotProvider'
import { useDispatch, useSelector } from 'react-redux'
import {
  IconBrain,
  IconDotsVertical,
  IconEdit,
  IconMessage2,
  IconPackage
} from '@tabler/icons-react'
//@ts-ignore
import { Button, Avatar } from 'dsm-react-lib'
import { useNavigate } from 'react-router-dom'
import { setSelectedAgent } from '../../../../_redux/actions/chatbotActions'
import { defaultBreadcrumbs } from '../../../../@core/layouts/new-VerticalLayout'
import { setBreadCrumbMapper } from '../../../../_redux/actions/breadCrumbMapperAction'
import { getInitials } from '../../../../utility/Utils'
import { DropdownMenuContainer } from '../../../../styles/common'
import { DropdownOption } from '../../Applications/styles'

export const PersonalAssistantCard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'my-agents' | 'explore'>('my-agents')
  const [isDotsHovered, setIsDotsHovered] = useState(false)
  const { appendToken } = useSasToken()
  const { agentsList } = useSelector((state: any) => state.agentReducer)
  const personalAssistant = agentsList?.find((agent: any) => agent?.isPersonalAssistant)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const breadcrumbsMapper = [
    {
      ...defaultBreadcrumbs,
      onClick: () => navigate('/')
    },
    {
      label: 'Agents'
    }
  ]

  useEffect(() => {
    dispatch(setBreadCrumbMapper(breadcrumbsMapper))
  }, [])

  const statsData = [
    { icon: <IconPackage size={36} stroke={1} />, label: 'Databoxes', count: 24 },
    { icon: <IconPackage size={36} stroke={1} />, label: 'Files', count: 24 },
    { icon: <IconPackage size={36} stroke={1} />, label: 'Data prod.', count: 24 }
    // { icon: <IconPackage size={36} stroke={1} />, label: 'Plugins', count: 24 },
    // { icon: <IconPackage size={36} stroke={1} />, label: 'Memories', count: 24 }
  ]

  return agentsList && agentsList.length > 0 ? (
    <div className="bg-surface-muted p-2 w-full h-full overflow-y-auto">
      {/* Header Section */}
      <h3 className="font-bold text-dark ml-1">AI Agents</h3>
      <span className="ml-1">
        Create, explore, and manage agents customised for your tasks and workflows.
      </span>
      <div className="w-fit theme-overlay-card p-1 my-1">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-26 h-26 rounded-full flex items-center justify-center mr-4">
              <Avatar
                content={
                  personalAssistant?.avatarUrl ||
                  getInitials(personalAssistant?.name || 'Personal Assistant')
                }
                className="!w-[5rem] !h-[5rem] !text-3xl"
              />
            </div>
            <div className="ml-1 mr-5 flex-1">
              <div className="mb-50">
                <h3 className="text-2xl font-semibold !mb-0 text-dark whitespace-nowrap">
                  {personalAssistant?.name}
                </h3>
              </div>
              <p className="text-gray-600 text-sm line-clamp-3 max-w-[400px]">
                {personalAssistant?.description}
              </p>
              <div className="mt-1">
                <Button
                  className="px-1"
                  color="primary"
                  label="Chat"
                  icon={<IconMessage2 size={16} />}
                  onClick={() => {
                    dispatch(setSelectedAgent({ ...personalAssistant }))
                    navigate('/chat')
                  }}
                />
              </div>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="flex gap-50 items-start height-full h-[-webkit-fill-available]">
            <UncontrolledDropdown direction="start">
              <DropdownToggle
                tag="span"
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
                onMouseEnter={() => setIsDotsHovered(true)}
                onMouseLeave={() => setIsDotsHovered(false)}
                className="cursor-pointer">
                <IconDotsVertical
                  size={24}
                  stroke={1.8}
                  color={isDotsHovered ? 'var(--color-primary)' : undefined}
                />
              </DropdownToggle>
              <DropdownMenuContainer $positionFixed={true} style={{ right: '0', left: 'auto' }}>
                <DropdownItem
                  className="w-100 theme-dropdown-accent-item"
                  onClick={() => navigate(`/agents/edit-agent/${personalAssistant?.id}`)}>
                  <DropdownOption className="flex items-center">
                    <IconEdit size={15} stroke={1.5} />
                    <span className="align-middle ms-50">Manage</span>
                  </DropdownOption>
                </DropdownItem>
                <DropdownItem
                  className="w-100 theme-dropdown-accent-item"
                  onClick={() => navigate(`/agents/${personalAssistant?.id}/memories`)}>
                  <DropdownOption className="flex items-center">
                    <IconBrain size={15} stroke={1.5} />
                    <span className="align-middle ms-50">Memories</span>
                  </DropdownOption>
                </DropdownItem>
              </DropdownMenuContainer>
            </UncontrolledDropdown>
            {/* {statsData.map((stat, index) => (
              <div
                key={index}
                className="bg-white border !border-[var(--color-primary)] rounded-lg py-1 flex flex-col items-center min-w-[100px]">
                <div className="mb-50 text-[var(--color-primary)]">{stat.icon}</div>
                <span className="text-[var(--color-primary)] mb-50">{stat.label}</span>
                <span className="text-2xl font-bold text-dark">{stat.count}</span>
              </div>
            ))} */}
          </div>
        </div>
      </div>

      {/* Navigation Tabs Card */}
      <div className="theme-overlay-card p-2 mb-1 mx-0">
        {/* Tabs Row */}
        {/* <div className="flex items-center justify-start mb-2">
          <div className="flex items-center gap-1">
            <div
              onClick={() => setActiveTab('my-agents')}
              className="cursor-pointer flex items-center relative hover:bg-gray-100 rounded-lg p-1 transition-colors">
              <span
                className={`text-lg ${
                  activeTab === 'my-agents' ? 'text-[var(--color-primary)]' : 'text-gray-600'
                }`}>
                My Agents
              </span>
              {activeTab === 'my-agents' && (
                <div className="absolute left-0 right-0 -bottom-1 h-1 bg-[var(--color-primary)] rounded-full" />
              )}
            </div>
            <div
              onClick={() => setActiveTab('explore')}
              className="cursor-pointer flex items-center relative hover:bg-gray-100 rounded-lg p-1 transition-colors">
              <IconFiles
                size={20}
                className={
                  activeTab === 'explore' ? 'text-[var(--color-primary)]' : 'text-gray-600'
                }
              />
              <span
                className={`text-lg ml-2 ${
                  activeTab === 'explore' ? 'text-[var(--color-primary)]' : 'text-gray-600'
                }`}>
                Explore (27)
              </span>
              {activeTab === 'explore' && (
                <div className="absolute left-0 right-0 -bottom-1 h-1 bg-[var(--color-primary)] rounded-full" />
              )}
            </div> 
          </div>
        </div> */}

        {activeTab === 'my-agents' && (
          <div className="flex flex-wrap">
            <MyAgents />
          </div>
        )}
        {/* {activeTab === 'explore' && <Explore isPlugin={false} setActiveTab={setActiveTab} />} */}
      </div>
    </div>
  ) : (
    <div className="flex justify-center items-center h-screen w-screen">
      <Spinner color="primary" />
    </div>
  )
}

export default PersonalAssistantCard
